import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderPlay = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 18.0001L16 14.5V21.5L22 18.0001Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.4141 5H23V15.1074L21 13.9404V7H12.5859L9.58594 4H3V19H13V21H1V2H10.4141L13.4141 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFolderPlay.js.map